
void function(player){
  const data = player.data
  let storeObs = null //intersection observer for avail visibility tracking
  player.trkData = {}

  // keep track of stores we've already seen through interception observer.
  // We disconnect observer and rebind all results after next requests are completed,
  // so an avail from initial request can have been tracked already and should not trigger a storeDisplayed event.
  let observedStores = []

  let availAborter = null // AbortController to cancel a running request

  // fetch availabilities
  async function getAvails(forceLoc){
    let url
    try{
      const {wtbid} = data
      const {product, location} = player.store
      const country = location && location.country || data.country

      if (!product) return

      document.dispatchEvent(new CustomEvent('loader-start'))

      url = `https://wtb-api-hub.swaven.com/wtb/v2/api/search/availabilities/${product.ean}?wtbid=${wtbid}&lang=${data.locale}&country=${country}`

      if (location && !forceLoc){
        if (location.lat)
          url += `&lat=${location.lat}`
        if (location.lng)
          url += `&lng=${location.lng}`
        if (location.country)
          url += `&cc=${location.country}`
        if (location.zipCode)
          url += `&zc=${location.zipCode}`
      }

      if (data.draft)
        url += '&draft=1'

      if (availAborter)
        availAborter.abort() // cancel previous request

      availAborter = new AbortController()

      const res = await fetch(url, {credentials: 'include', signal: availAborter.signal})
      
      if (res.status != 200){
        console.error(`avails fetch: error ${res.status}`)
        return
      }
      
      const response = await res.json()

      // APEX-27: Make additional requests if any
      let hasNext = response.next && response.next.length
      if (hasNext){
        getOtherRetailers(response.next, availAborter.signal)
      }
      
      // mapping json data to AWE's own model.
      // Provided object is to replace macros in clkUrl.
      let avails = Mapping.mapAvailabilities(response.d, {
        PAGEID: data.pageId,
        IID: data.iid,
        RFR: player.baseTrk.rfr,
        RFR2: player.baseTrk.rfr2
        //SID: this.tracker.session && this.tracker.session.id,
        //SURL: this.tracker.session && this.tracker.session.url,
        //SRFR: this.tracker.session && this.tracker.session.referrer
      })

      if (!location || location.lat == null || !!forceLoc){
        player.store.location = {
          lat: response.loc.Latitude,
          lng: response.loc.Longitude,
          city: response.loc.City,
          country: response.loc.Country,
          zipCode: response.loc.ZipCode,
          state: response.loc.State,
          address: response.loc.Address,
          origin: 'api'
        }
      }

      // Retailer view: group avails by typology or retailer id
      if (player.data.availsView === 'retailer'){
        avails = setRetailerView(avails)
      }

      player.store.avails = avails

      document.dispatchEvent(new CustomEvent('availabilities-update', {
        detail: {
          avails: player.store.avails,
          fallbackStoreId: response.dsid
        }
      }))

      player.trkData = {
        avgpc: response.avgp,
        avgdst: response.avgdst,
        nbres: response.nbres,
        nbrefret: response.nbrefret,
        avreqid: uuid()
      }

      // reset current availability if not present if newly retrieved results.
      // if present, assign new object.
      if (player.store.currentAvail){
        const curInNewAvails = player.store.avails.find(x => x.store.id === player.store.currentAvail.store.id)
        player.store.currentAvail = curInNewAvails || null
      }

      observeStores(true)

      const tm = performance.getEntriesByName(url).pop()
      const v = tm ? Math.round(tm.duration) : null
      tracker.track('apires', v ? {duration:v} : {})
      tracker.track('api-avails', {...(v ? {availReqTime: v} : {}), log: true})

      if (response.usids && response.usids.length > 0)
      tracker.track('unavlbsids', {sids: response.usids.slice(0, 20)})

      console.debug(`avails req ${v}ms`)

    }
    catch(ex){
      if (ex.name !== 'AbortError')
        throw ex
    }
    finally{
      document.dispatchEvent(new CustomEvent('loader-end'))
    }
  }
  player.getAvails = getAvails


  // make additional availabilities requests for real-time retailers.
  // urls: list of urls to query
  // signal: AbortSignal to allow request cancellation.
  async function getOtherRetailers(urls, signal){
    const proms = new Array(urls.length)

    for (let i = 0; i < urls.length; i++){
      const url = urls[i]
      const p = new Promise(async (resolve) => {
        try{
          const resp = await fetch(url, {
            credentials: 'include',
            signal,
          })

          const response = await resp.json()

          const avails = Mapping.mapAvailabilities(response, {
            PAGEID: data.pageId,
            IID: data.iid,
            RFR: player.baseTrk.rfr,
            RFR2: player.baseTrk.rfr2,
          })
          resolve(avails)
        }
        catch(ex){
          if (ex.name !== 'AbortError'){
            console.error(ex)
          }
          resolve([]) // resolve anyway, or Promise.all will reject
        }
      })
      // put promises in an array to wait for globally
      proms[i] = p
    }

    // lazy-loading module while awaiting requests completion
    const [utils, allNext] = await Promise.all([
      import('./realtime.mjs'),
      Promise.all(proms),
    ])

    let avails = utils.mergeAvailLists(player.store.avails, [].concat(...allNext), player.data.availSortOrder, player.data.retailerPrio)
    
    // Retailer view: group avails by typology or retailer id
    if (player.data.availsView === 'retailer'){
      avails = setRetailerView(avails)
    }

    player.store.avails = avails
    document.dispatchEvent(new CustomEvent('availabilities-update', {
      detail: {
        avails: player.store.avails
      }
    }))

    utils.updateTrackingData(player.store.avails, player.trkData)
    observeStores(false)
  }

  // Retailer view: filter list to contains only one result for each retailer.
  function setRetailerView(avails){
    const typos = []
    const filtered = avails.filter(x => {
      const typo = x.store.typologyId || x.retailer.id
      if (typos.includes(typo))
        return false
      else{
        typos.push(typo)
        return true
      }
    })
    return filtered
  }


  // on availability click, triggers the desired behavior.
  player.redirect = (evt, avail, mode) => {
    if (evt){
      evt.stopPropagation()
      evt.preventDefault()
    }

    if (avail != player.store.currentAvail)
      player.store.currentAvail = avail

    if (!mode && evt)
      mode = evt.currentTarget.dataset.redirectMode

    const openLink = window.aweParams && window.aweParams.clickThrough || window.open

    switch(mode){
      case 'map':
        openLink(avail.store.gmapUrl)
        tracker.track('clkloc', {avail: avail, outbound: true, auto:0})
        break
      case 'phone':
        openLink(`tel:${avail.store.phone}`)
        tracker.track('clkloc', {avail: avail, clkloc_type: 'tel', auto:0})
        break
      case 'whatsapp':
        openLink(`https://api.whatsapp.com/send?phone=${avail.store.whatsapp}&text=${player.data.remoteConf.whatsapp_message}`)
        tracker.track('clkloc', {avail: avail, clkloc_type: 'whatsapp', auto:0})
        break
      case 'appointment':
        openLink(avail.store.appointmentUrl)
        tracker.track('clkloc', {avail, clkloc_type: 'appointment', auto:0})
        tracker.track('appointment', {avail})
        break
      case '2step':
        openLink(avail.voucher.secondStepUrl, '_self')
        tracker.track('2step', {avail})
        break
      case 'url':
      case 'voucher':
      default:
        const data  = {avail: avail, leadid: avail.leadid, outbound: true, auto: false}
        if (mode === 'voucher')
          data.buy_type = mode

        tracker.track('buy', data)
        // this.trigger('product-buy', {avail: avail, leadid: avail.leadid})
        openLink(avail.clkUrl || avail.store.url || avail.retailer.url)
        
        // generate a new leadid
        player.resetLeadid(avail)
    }
  }

  // generate a new leadid for avail and updates the clkUrl
  player.resetLeadid = (avail) => {
    if (!avail) return
    
    avail.leadid =  uuid().replace(/-/g, '')
    avail.clkUrl = avail.rawClkUrl.replace('{SWN-LEADID}', avail.leadid)
  }


  player.selectProduct = (idx, auto = false) => {
    player.store.product = data.products[idx]
    player.trkData = {}
    getAvails()
    tracker.track('clk', {auto, autoSel: auto})
  }

  // IntersectionObserver callback for storeDisplayed tracking.
  function intersectionCallback(entries, obs){
    const ids = []
    entries.forEach(entry => {
      // an entry is sometimes included even if its ratio is below the threshold, so we check that explicitely
      if (entry.isIntersecting && entry.intersectionRatio >= obs.thresholds[0]){
        obs.unobserve(entry.target) // no need to further observe an availability once it's been tracked
        ids.push(entry.target.dataset.sid)
        observedStores.push(entry.target.dataset.sid)
      }
    })

    if (ids.length){
      const trk = {sids: ids}
      if (player.data.hasVouchers)
        trk.with_vouchers = player.store.avails.filter(x => ids.includes(x.store.id) && x.voucher).map(x => x.store.id).join(',')

      tracker.track('storeDisplayed', trk)
    }
  }

  // plug observer on stores, for tracking when they become visible.
  // reset: boolean, whether to clear cache of stores already displayed.
  function observeStores(reset){
    if (!window.IntersectionObserver) return

    if (reset)
      observedStores = []
  
    if (storeObs)
      storeObs.disconnect()
    else{
      storeObs = new IntersectionObserver(intersectionCallback, {
        root: null, // root node is viewport
        rootMargin: '0px',
        threshold: .5
      })
    }
  
    // get all availability nodes and observe them
    const nds = document.getElementsByClassName('_avail')
    for (let i = 0; i < nds.length; i++){
      if (!observedStores.includes(nds[i].dataset.sid))
        storeObs.observe(nds[i])
    }
  }

  // get browser geoloc, and update availabilities on success.
  function requestGeoloc(){
    navigator.geolocation.getCurrentPosition(pos => {
      if (pos && pos.coords){
        getReverseGeocoding(pos.coords.longitude, pos.coords.latitude).then(location =>{
          // accept only if country is not OOS
          if (player.data.countries.includes(location.country) )
            player.store.location = location
        })
        .catch(err =>{ console.error(err) })
      }
    }, err => {console.warn(err.message)}, {timeout: 1e4})     
  }

  // makes a browser geoloc request, with a fallback to get avails.
  function autoloc(){
    try{
      requestGeoloc()
    }
    catch(ex){
      getAvails(true)
    }
    finally{
      // TODO: track geoloc
    }
  }
  player.autoloc = autoloc

  // returns location from lat/lng coordinates.
  async function getReverseGeocoding(lng, lat, countries = [], language = null, source = '', auto, cb){
    let qs = 'access_token=pk.eyJ1Ijoic3dhdmVuIiwiYSI6ImNqbTd1dXBlcjFhejMzcHBvajVlYjFjMXcifQ.ljVSrON2CjvnSj38Nxa9RA'

    if (countries.length > 0)
      qs+= `&country=${typeof countries === 'string' ? countries : countries.join(',')}`
    if (language)
      qs+= `&language=${language}`

    try{
      const res = await fetch(`https://api.mapbox.com/geocoding/v5/mapbox.places/${lng},${lat}.json?${qs}`),
            data = await res.json()

      if (res.status >= 400)
        throw new Error(data.message)

      if (data.features.length === 0)
        return null

      return parseFeature(data.features[0])
    }
    catch(ex){
      console.error(ex)
      return null
    }
  }
  player.getReverseGeocoding = getReverseGeocoding

  function parseFeature(feat){
    if (!feat)
      return null

    const place = {
      lng: feat.center[0],
      lat: feat.center[1],
      country: '',
      zipCode: '',
      address: feat.place_name
    }

    if (feat.place_type.includes('postcode'))
      place.zipCode = feat.text

    if (feat.place_type.includes('country') && feat.properties.short_code)
      place.country = feat.properties.short_code.toUpperCase()

    if (feat.context){
      feat.context.forEach(context => {
        let type = context.id.split('.')[0]
        if ((type === 'country' || type ==='region' && !place.country) && !!context.short_code)
          place.country = context.short_code.toUpperCase()
        else if (type === 'postcode' && !place.zipCode)
          place.zipCode = context.text
      })
    }

    return place
  }
  player.parseFeature = parseFeature

  function locationUpdated(location){
    // no need to make new request if location update already comes from api
    if (location.origin !== 'api') 
      getAvails()

    document.dispatchEvent(new CustomEvent('location-update', { detail: {location}, bubbles: true }))
  }

  function currentAvailUpdated(avail, old){
    document.body.dispatchEvent(new CustomEvent('availability-select', {detail: {avail}, bubbles: true}))
  }

  /*************************************************************
                    Entry point
  **************************************************************/
  void async function init(){
    if (player.data.touchpoint === 'IP'){
      tracker.track('dploy', {auto: true})
      tracker.track('visible')
      tracker.track('clk', {auto: true, autoSel: true})
    }

    // default watchers
    sre.watch({
      location: locationUpdated,
      currentAvail: currentAvailUpdated
    })

    await sre.start(player)
    
    document.body.addEventListener('mouseenter', () => {
      tracker.track('mover')
    }, {once: true, passive: true})

    if (player.data.touchpoint === 'IP')
      getAvails()

    if (!data.remoteConf.noAutoGeoloc && !data.media){
      try{
        requestGeoloc()
      }
      catch(ex){ console.warn(ex) }
    }

    // bind 'view all' button
    const moreBtn = document.getElementById('more')
    if (moreBtn){
      moreBtn.addEventListener('click', e => {
        const showAll = document.getElementById('avails-ctnr').classList.toggle('show-all')
        const lbl = e.currentTarget.textContent
        e.currentTarget.textContent = e.currentTarget.dataset.altLabel
        e.currentTarget.dataset.altLabel = lbl
      })
    }

    if (player.data.products.length > 1){
      document.addEventListener('slider-select', e => {
        player.selectProduct(e.detail.idx, e.detail.auto)
      })
    }
  }()

}(window.player)

window.fillString = function(txt, pattern, value){
  return txt.replace(new RegExp(`{${pattern}}`, 'g'), value)
}
